import { Component, OnInit } from "@angular/core";
import { LocalDataSource } from "angular2-smart-table";
import { ToastrService } from "../../services/toastr/toastr.service";
import { ActivatedRoute } from "@angular/router";
import {
  HTUsersService,
  IHTUsers,
} from "../../services/htusers/htusers.service";

@Component({
  selector: "ngx-horeca-touch",
  templateUrl: "./horeca-touch.component.html",
  styleUrls: ["./horeca-touch.component.scss"],
})
export class HorecaTouchComponent implements OnInit {
  htUsers: IHTUsers[];
  source: LocalDataSource = new LocalDataSource();
  searchValue: string;
  users: any[];
  userKey: string;
  eventId: string;

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: true,
      position: "right",
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      key: {
        title: "Key",
        show: "false",
      }
    },
  };

  constructor(
    private htUsersService: HTUsersService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get("eventId");
    this.htUsersService.getUsers(this.eventId).subscribe((users) => {
      const data = [];
      users.forEach((user) => {
        data.push({
          key: user.key,
        });
      });
      this.source.load(data);
    });
  }

  onDeleteConfirm(event): void {
    if (window.confirm("Are you sure you want to delete this manager?")) {
      this.htUsersService
        .deleteUser(this.eventId, event.data.key)
        .then((succes) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show(
            "Success",
            "Successfully deleted Horeca Touch token",
            "success"
          );
          event.confirm.resolve();
        })
        .catch((error) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show("Error", error, "danger");
        });
    } else {
      event.confirm.reject();
    }
  }

  addUser() {
    this.htUsersService
      .addUser(this.eventId)
      .then((succes) => {
        this.searchValue = "";
        this.userKey = null;
        this.toastrService.show(
          "Success",
          "Successfully added Horeca Touch user",
          "success"
        );
      })
      .catch((error) => {
        this.toastrService.show("Error", error, "danger");
      });
  }
}
